import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskServiceModalNewRoute } from '@atlassian/jira-router-routes-servicedesk-services-routes/src/servicedeskServiceModalNewRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import ServiceCreateModalWithoutProjectContext, {
	LazyServiceCreateModalWithProjectContext,
} from './ui/service-create-modal-without-project-context/index.tsx';

export const servicedeskServiceModalNewRouteEntry = createEntry(
	servicedeskServiceModalNewRoute,
	() => ({
		group: 'servicedesk',
		component: ServiceCreateModalWithoutProjectContext,
		layout: serviceProjectLayout,
		resources: [...getServiceDeskNavigationResources(), ...getServicedeskPageContextResources()],
		forPaint: [LazyAtlassianNavigation, LazyServiceCreateModalWithProjectContext],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-services-entries/src/servicedeskServiceModalNewRouteEntry.tsx',
				whichExportToUse: 'servicedeskServiceModalNewRouteEntry',
			},

			enabled: true,
		},
	}),
);
